import { Constants, DispatchToCustomer, DispatchItemsDto } from '../../../../../core';
const validateState = (state): string => {
  let stateComplete = '';
  Constants.Order.DISPATCH_STATUS.forEach(element => {
    if (state === element.value) {
      stateComplete = element.text;
    }
  });
  return stateComplete;
};


// export const dispatchesToLoad = JSON.parse(JSON.stringify(dispatchToCustomer));
export const dispatchesToLoad = {
  hasDisabledCheckBoxItem: (row: DispatchToCustomer, selection: DispatchToCustomer[], data: any) => {
    if (row.state !== Constants.SaleNoteStatusConfig.PAYED && row.state !== Constants.SaleNoteStatusConfig.PAYMENT_PENDING) {
      return true;
    }
    if (row && row.dispatchItemsDto) {
      let countStateDispatch = 0;
      row.dispatchItemsDto.forEach((item: DispatchItemsDto) => {
        if (!item.stateDispatch
          || (item.state && item.state.toUpperCase() === Constants.DISPATCH_STATUS_LIST.CANCELLED.text)
          || (item.canceledAmount === item.totalAmount)
          || (item.totalAmount < 0
            || item.processedAmount < 0
            || item.pendingAmount < 0)
          // || item.notPickingWms
        ) {
          countStateDispatch++;
        }
      });

      if (countStateDispatch === row.dispatchItemsDto.length) {
        if (data) {
          data.deselect(row);
        }
        return true;
      } else {
        return false;
      }
    }
    return false;
  },
  classValidation: (row: any) => {
    if (row.state !== Constants.SaleNoteStatusConfig.PAYED && row.state !== Constants.SaleNoteStatusConfig.PAYED) {
      return 'pending';
    }
    return '';
  },
  export: false,
  sort: false,
  dialogHability: true,
  filter: false,
  checkbox: true,
  paginator: true,
  exportFile: 'despacho_clientes.xlsx',
  expandable: true,
  disabled: false,
  partialField: '',
  iconsOfActions: [
    { icon: 'operations', tooltip: 'Crear viaje' }
  ],
  paginatorAllData: true,
  columns: [
    {
      title: 'N° de NV',
      name: 'saleNoteId',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.saleNoteId
    },
    {
      title: 'N° de despacho',
      name: 'dispatchId',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.dispatchId
    },
    {
      title: 'Distrito',
      name: 'dispatchDistrict',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.dispatchDistrict
    },
    {
      title: 'Zona de despacho',
      name: 'dispatchZone',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.dispatchZone
    },
    {
      title: 'Entidad',
      name: 'currentEntityName',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.currentEntityName
    },
    {
      title: 'Fecha de entrega',
      name: 'deliveryDate',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.deliveryDate
    },
    {
      title: 'Estado NV',
      name: 'state',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      sort: true,
      value: (element: any) => validateState(element.state)
    }
  ]
};



// export const dispatchesToLoad = JSON.parse(JSON.stringify(dispatchToCustomer));
export const dispatchesToLoadTrip = {
  hasDisabledCheckBoxItem: (row: DispatchToCustomer, selection: DispatchToCustomer[], data: any) => {
    if (row.state !== 'PAYED') {
      return true;
    }
    if (row && row.dispatchItemsDto) {
      let countStateDispatch = 0;
      row.dispatchItemsDto.forEach((item: DispatchItemsDto) => {
        if (!item.stateDispatch
          || (item.state && item.state.toUpperCase() === Constants.DISPATCH_STATUS_LIST.CANCELLED.text)
          || (item.canceledAmount === item.totalAmount)
          || (item.totalAmount < 0
            || item.processedAmount < 0
            || item.pendingAmount < 0)
          // || item.notPickingWms
        ) {
          countStateDispatch++;
        }
      });

      if (countStateDispatch === row.dispatchItemsDto.length) {
        if (data) {
          data.deselect(row);
        }
        return true;
      } else {
        return false;
      }
    }
    return false;
  },
  classValidation: (row: any) => {
    if (row.state !== 'PAYED') {
      return 'pending';
    }
    return '';
  },
  export: false,
  sort: false,
  dialogHability: true,
  filter: false,
  checkbox: true,
  paginator: true,
  exportFile: 'despacho_clientes.xlsx',
  expandable: true,
  disabled: false,
  partialField: '',
  iconsOfActions: [
    { icon: 'operations', tooltip: 'Crear viaje' }
  ],
  paginatorAllData: true,
  columns: [
    {
      title: 'N° de Viaje',
      name: 'tripCode',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.tripCode
    },
    {
      title: 'N° de NV',
      name: 'saleNoteId',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.saleNoteId
    },
    {
      title: 'N° de despacho',
      name: 'dispatchId',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.dispatchId
    },
    {
      title: 'Distrito',
      name: 'dispatchDistrict',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.dispatchDistrict
    },
    {
      title: 'Zona de despacho',
      name: 'dispatchZone',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.dispatchZone
    },
    {
      title: 'Entidad',
      name: 'currentEntityName',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.currentEntityName
    },
    {
      title: 'Fecha de entrega',
      name: 'deliveryDate',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.deliveryDate
    },
    {
      title: 'Estado NV',
      name: 'state',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      sort: true,
      value: (element: any) => validateState(element.state)
    }
  ]
};
